module.exports = "mutation contactInsurer($contactInput:ContactInput!){contactInsurer(contactInput:$contactInput)}"